import { render, staticRenderFns } from "./ConfigurationWizardCreateEvent.vue?vue&type=template&id=15f19f12&"
import script from "./ConfigurationWizardCreateEvent.vue?vue&type=script&lang=js&"
export * from "./ConfigurationWizardCreateEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports